/* ============================================================================
   HOST PREVIEW — render the REAL design host view (window.HostApp) for the
   logged-in super-admin, as themselves.
   ----------------------------------------------------------------------------
   No new UI and no data injection: the store is already live (hydrated at boot by
   liveDataSource), so we just build a host-scoped scope for the operator and hand
   it to the same HostApp a real host sees. Their own meditations are their host
   circles. "Log out" / "Exit" returns to the admin console. See plan/07 §11.
   ============================================================================ */
import React from 'react';
import { buildHostScope } from './liveDataSource';

function Splash(props: { text: string }): React.ReactElement {
  return (
    <div
      className="yp-root"
      style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', color: 'var(--sub)', fontSize: 13 }}
    >
      {props.text}
    </div>
  );
}

function ExitButton(props: { onExit?: () => void }): React.ReactElement {
  return (
    <div style={{ position: 'fixed', top: 14, right: 16, zIndex: 400 }}>
      <span
        className="yp-btn"
        onClick={props.onExit}
        style={{
          fontSize: 12,
          color: 'var(--ink)',
          background: 'var(--panel-2)',
          border: '1px solid var(--line)',
          borderRadius: 10,
          padding: '7px 12px',
          backdropFilter: 'blur(8px)',
        }}
      >
        ← Exit host preview
      </span>
    </div>
  );
}

export function HostPreview(props: {
  themeKey?: string;
  cycleTheme?: () => void;
  onExit?: () => void;
}): React.ReactElement {
  const scope = buildHostScope();
  const HostApp = (window as unknown as { HostApp?: { HostApp?: React.ComponentType<Record<string, unknown>> } })
    .HostApp?.HostApp;

  return (
    <>
      <ExitButton onExit={props.onExit} />
      {HostApp && scope ? (
        React.createElement(HostApp, {
          scope,
          themeKey: props.themeKey,
          cycleTheme: props.cycleTheme,
          onLogout: props.onExit, // host-bar "Log out" exits the preview
        })
      ) : (
        <Splash text="Host view unavailable." />
      )}
    </>
  );
}
